import { render, staticRenderFns } from "./fundos-imobiliarios.vue?vue&type=template&id=e1026c56&scoped=true&"
import script from "./fundos-imobiliarios.vue?vue&type=script&lang=js&"
export * from "./fundos-imobiliarios.vue?vue&type=script&lang=js&"
import style0 from "./fundos-imobiliarios.vue?vue&type=style&index=0&id=e1026c56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1026c56",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1026c56')) {
      api.createRecord('e1026c56', component.options)
    } else {
      api.reload('e1026c56', component.options)
    }
    module.hot.accept("./fundos-imobiliarios.vue?vue&type=template&id=e1026c56&scoped=true&", function () {
      api.rerender('e1026c56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Modal/tiposAtivos/RendaVariavel/fundos-imobiliarios.vue"
export default component.exports